import React, { useState } from 'react';
import { ChevronRightIcon, LandmarkIcon } from 'lucide-react';
import { boardRole } from '../data/profile';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function BoardModule({
  showLabel = true
}: {
  showLabel?: boolean;
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = boardRole.focus[activeIndex];
  return <section id="board-experience" className="w-full bg-canvas py-20 lg:py-28" data-id="element-67" data-mp="112u4kfkmu6ko">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-68" data-mp="wcdoenpfg6um">
        {showLabel && <Reveal data-id="element-69" data-mp="waaq7ge4f7et">
            <SectionLabel data-id="element-70" data-mp="rdak55h9u4np">Board Experience</SectionLabel>
            <h2 className="mt-6 max-w-2xl font-serif text-[32px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-4xl lg:text-[44px]" data-id="element-71" data-mp="rdtzcefjeey1">
              Advisory service at the leadership table
            </h2>
          </Reveal>}

        <Reveal delay={0.05} data-id="element-72" data-mp="ddrjexqshvlf">
          <div className={`border border-line bg-white shadow-[0_1px_40px_rgba(15,23,42,0.05)] ${showLabel ? 'mt-12' : ''}`} data-id="element-73" data-mp="deuc9b7oa83z">
            <div className="grid grid-cols-1 lg:grid-cols-[0.34fr_0.66fr]" data-id="element-74" data-mp="1ve6hpvl9tdjk">
              <div className="flex flex-col justify-center gap-6 border-b border-line bg-navy p-9 lg:border-b-0 lg:p-10" data-id="element-75" data-mp="1hm8lglcnrc4t">
                <img src={boardRole.logoUrl} alt={`${boardRole.company} logo`} className="h-16 w-16 bg-white object-contain p-1" data-id="element-76" data-mp="1ln27182moeuj" />
                <div data-id="element-77" data-mp="2ecr8tnn5wix7">
                  <h3 className="font-serif text-2xl font-semibold tracking-tight text-white" data-id="element-78" data-mp="2eb7uw3ozajyl">
                    {boardRole.company}
                  </h3>
                  <p className="mt-2 text-sm font-medium text-white/80" data-id="element-79" data-mp="25bkpz7x1iw0s">{boardRole.role}</p>
                  <p className="mt-4 inline-flex items-center gap-2 text-[12px] font-medium uppercase tracking-label text-metal-light" data-id="element-80" data-mp="oxkvicgyrykx">
                    <span className="h-1.5 w-1.5 rounded-full bg-metal" aria-hidden="true" data-id="element-81" data-mp="txp7pqaua75c" />
                    {boardRole.period}
                  </p>
                </div>
                <p className="mt-2 border-t border-white/10 pt-6 text-[14px] leading-relaxed text-white/60" data-id="element-82" data-mp="2qm8j5a7a2zxy">
                  {boardRole.value}
                </p>
              </div>

              <div className="p-9 lg:p-12" data-id="element-83" data-mp="2huf1fkg0jj6s">
                <h4 className="text-[12px] font-semibold uppercase tracking-label text-charcoal-muted" data-id="element-84" data-mp="2htnfl1c7wztp">
                  Strategic focus
                </h4>

                <div className="mt-6 grid grid-cols-1 gap-8 md:grid-cols-[0.44fr_0.56fr]" data-id="element-85" data-mp="27win6jrs484g">
                  <ul className="flex flex-col" role="tablist" aria-label="Strategic focus areas" data-id="element-86" data-mp="22x60bz0wr11v">
                    {boardRole.focus.map((item, index) => {
                    const isActive = index === activeIndex;
                    return <li key={item.title} data-id="element-87" data-mp="159i66k8isy4" data-mpi={index}>
                          <button type="button" role="tab" aria-selected={isActive} onClick={() => setActiveIndex(index)} className={`flex w-full items-center justify-between gap-3 border-l-2 py-4 pl-4 pr-2 text-left text-[15px] font-medium transition-colors duration-150 ease-premium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy ${isActive ? 'border-metal text-navy' : 'border-line text-charcoal-muted hover:border-navy/30 hover:text-navy'}`} data-id="element-88" data-mp="3t9v8eb1ukws6">
                            {item.title}
                            <ChevronRightIcon className={`h-4 w-4 shrink-0 transition-opacity duration-150 ease-premium ${isActive ? 'text-metal opacity-100' : 'opacity-0'}`} aria-hidden="true" data-id="element-89" data-mp="1a2hnl5abnpqb" />
                          </button>
                        </li>;
                  })}
                  </ul>

                  <div role="tabpanel" className="border-t border-line pt-6 md:border-l md:border-t-0 md:pl-8 md:pt-0" data-id="element-90" data-mp="2f3zg8m5677s4">
                    <p className="font-serif text-[20px] leading-[1.5] text-navy" data-id="element-91" data-mp="2oyj2i2ia2xdt">{active.title}</p>
                    <p className="mt-4 text-[15px] leading-[1.7] text-charcoal-light" data-id="element-92" data-mp="32xqyynn23reb">
                      {active.detail}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-4 border-t border-line bg-canvas p-8 sm:flex-row sm:items-center sm:gap-6 lg:px-10" data-id="element-93" data-mp="37qk6fj9wtdu3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-metal" data-id="element-94" data-mp="3lr4qeirk9fp6">
                <LandmarkIcon className="h-5 w-5 text-metal" aria-hidden="true" data-id="element-95" data-mp="3gsbaykspremd" />
              </span>
              <div data-id="element-96" data-mp="48peh4wtbh8a">
                <p className="text-[12px] font-semibold uppercase tracking-label text-charcoal-muted" data-id="element-97" data-mp="4876xc4p9gl2">
                  {boardRole.priorBoard.role} · Prior
                </p>
                <p className="mt-1.5 font-serif text-lg font-semibold text-navy" data-id="element-98" data-mp="3rbbyzsv7qc28">
                  {boardRole.priorBoard.company}
                </p>
                <p className="mt-1.5 max-w-xl text-[14px] leading-relaxed text-charcoal-light" data-id="element-99" data-mp="3hmanofzm4iul">
                  {boardRole.priorBoard.detail}
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}